import React from 'lib/react';
import { useTranslation, Trans } from 'lib/translation';
import { useDispatch, useSelector } from 'lib/redux';
import {
  EVAlert,
  EVCheckbox,
  EVGrid,
  EVRadio,
  EVTypography,
  EVLink,
} from 'lib/components';
import HelpTooltip from 'commonComponents/helpTooltip/HelpTooltip.component';
import { STRUCTURE_TYPES, EAGLEVIEW_ORDERING_GUIDE_HELP, NEW_UNIFIED_SKUS } from 'constants/AppConstants';
import PropertyTypeStyles from './PropertyTypeStyles';
import BuildingDetailsList from './buildingDetailsList';
import { setIsComplex, setPropertyType, updateFocusedPointIndex } from '../Order.actions';

/**
 * Component that renders the radio and checkbox options for changing property type
 */
function PropertyTypeComponent() {
  const { t } = useTranslation();
  const classes = PropertyTypeStyles();
  const {
    mapPoints, isComplex, propertyType, userProducts, selectedPrimaryProduct, selectedWallsProduct,
  } = useSelector(({ order, orderAddresses, userData }) => ({
    isComplex: order.isComplex,
    propertyType: order.propertyType,
    userProducts: userData.userProducts,
    mapPoints: orderAddresses.mapPoints,
    selectedPrimaryProduct: order.selectedPrimaryProduct,
    selectedWallsProduct: order.selectedWallsProduct,
  }));
  const dispatch = useDispatch();
  const handlePropertyTypeChange = (e) => dispatch(setPropertyType(e.target.value));

  const isNewSKUSelected = (selectedPrimaryProduct && NEW_UNIFIED_SKUS.includes(selectedPrimaryProduct.ProductID))
    || (selectedWallsProduct && NEW_UNIFIED_SKUS.includes(selectedWallsProduct.ProductID));

  const handleComplex = () => dispatch(setIsComplex(!isComplex, isNewSKUSelected));

  const handleBuildingDetailClick = () => dispatch(updateFocusedPointIndex(null));

  return (
    <EVGrid container direction="column" className={classes.propertyType}>
      <EVGrid id="order-property-type" container direction="column" style={{ gap: '6px' }}>
        {(!isNewSKUSelected) && (
        <>
          <div className={classes.propertyTypeHeading}>{t('PropertyType')}</div>
          <EVGrid container alignItems="center" className={classes.propertyTypeRow}>
            {
              Object.values(STRUCTURE_TYPES).map((structureType) => (
                structureType in userProducts
                && (
                <EVGrid item className={classes.propertyTypeRadio} key={structureType}>
                  <EVRadio
                    checked={propertyType === structureType}
                    onChange={handlePropertyTypeChange}
                    color="primary"
                    id={structureType}
                    value={structureType}
                    name="property-type"
                    inputProps={{ 'aria-label': structureType }}
                    style={{ padding: 0 }}
                  />
                  <label htmlFor={structureType}>{t(structureType)}</label>
                </EVGrid>
                )
              ))
            }
          </EVGrid>
        </>
        )}
        <EVGrid container alignItems="center" className={classes.complexCheckbox}>
          <EVCheckbox
            checked={isComplex}
            onChange={handleComplex}
            id="complexCheckbox"
            color="primary"
            inputProps={{ 'aria-label': 'This is a complex' }}
            disabled={mapPoints.length > 1}
            style={{ padding: 0 }}
          />
          <label htmlFor="complexCheckbox">{t('ThisIsAComplex')}</label>
          <HelpTooltip title={(
            <EVTypography>
              <Trans i18nKey="ComplexTooltip" />
              <EVLink className={classes.complexTooltipLink} href={EAGLEVIEW_ORDERING_GUIDE_HELP}>
                {t('coming_soon__here')}
              </EVLink>
              .
            </EVTypography>
              )}
          />
        </EVGrid>
      </EVGrid>
      {isComplex && (
        <EVAlert
          className={classes.complexAlert}
          severity="info"
        >
          {t('ComplexAlert')}
        </EVAlert>
      )}
      <EVGrid
        id="order-building-details"
        style={{ margin: '0 -24px', padding: '0 24px' }}
        onClick={handleBuildingDetailClick}
      >
        <BuildingDetailsList />
      </EVGrid>
    </EVGrid>
  );
}

export default PropertyTypeComponent;
